import {
    StockLogoCategory,
    StocklogoEventnames,
    StockLogoPoolEntry
} from "@k/js/stocklogos/stocklogoController";
import {StockLogoFromBackend} from "@k/js/selectableObjects"
import globalsObject from "@k/js/globalsObject";
import {EventVerteiler} from "@k/global/eventVerteiler";
import axios from "axios";
import {SingleTextFileZipExtractor} from "@k/global/newZipLoader";


function loadStockLogoSVG(stockLogoID, stockLogoFromBackend):Promise<StockLogoFromBackend> {
    return new Promise<StockLogoFromBackend>(resolve=> {
        SingleTextFileZipExtractor.load("/konfigurator_php/stocklogos/getLogoByID.php?id=" + stockLogoID)
            .then(svg => {
                    stockLogoFromBackend.svg = svg;
                    resolve(stockLogoFromBackend);
                }
            );
    });
}

export default {
    namespaced:true,
    state: ()=>({
        categories: [] as StockLogoCategory[]

    }),
    getters: {
        getCategories : (state)=>state.categories,
        getCategory : (state)=>categoryName=>state.categories.find(c=>c.name === categoryName) || null,
        getCategoryForStockLogoID : (state)=> stockLogoID=> {
            for (let i = 0; i < state.categories.length; i++) {
                if (state.categories[i].logos.some(l => l.stockLogoID === stockLogoID)) {
                    return state.categories[i];
                }
            }
            return null;
        },
        getLogo : (state)=>id=>{
            return state.categories.reduce(function (carry, cat) {
                const logo = cat.logos.find(l=>l.stockLogoID === parseInt(id));
                return logo !== undefined ? logo : carry;
            }, null as StockLogoPoolEntry|null);
        },
        getSubCategories : (state)=>(categoryName: string)=>state.categories.filter(c => c.masterkategorie === categoryName),
        getPatternCategories : (state)=>state.categories.filter(c=>c.isPatternKategorie),
        getStockLogoCategories: (state)=>state.categories.filter(c=>!c.isPatternKategorie),
    },
    mutations:{
        SETSTOCKLOGOCATEGORIES : (state, stockLogoCategories:StockLogoCategory[])=>{
            state.categories = stockLogoCategories;
        },
    },
    actions:{
        loadStockLogos(context, language) {
            axios({
                method:"get",
                url:"/konfigurator_php/stocklogos/getAllLogos.php?lang="+language+"&sport="+globalsObject.controller.model.getWebsportFuerProduktAuswahlNormalized()
            }).then((response)=>{
                if(!Array.isArray(response.data)) {
                    response.data = Object.values(response.data);
                }

                globalsObject.resourceManager.registerLoadedResourceWithoutData("stocklogos");
                context.commit("SETSTOCKLOGOCATEGORIES", response.data);
                globalsObject.resourceManager.registerLoadedResourceWithoutData("stocklogosloaded");
                EventVerteiler.broadcast(StocklogoEventnames.LOGOSLOADED, context.getters.getCategories);
            })
        },
        addStockLogoToLibrary(context, stockLogoID) {
            axios({
                method:"get",
                url:"/konfigurator_php/stocklogos/addToLibrary.php?id=" + stockLogoID,
            }).then(()=>{
                EventVerteiler.broadcast("logoPoolChangedEvent");
                context.dispatch("loadLogoPool", null, {root:true});
            })
        },
        getOriginalSVG(context, stockLogoID) {
            return new Promise(function(resolve){
                axios({
                    method:"get",
                    url:"/konfigurator_php/stocklogos/getstocklogoInfo.php?id=" + stockLogoID,
                    responseType:"json"
                }).then((response)=>{
                    loadStockLogoSVG(stockLogoID, response.data).then(response=>resolve(response));
                })
            })
        },

        getVorschauSVG(context, stockLogoID) {
            return new Promise((resolve)=>{
                axios({
                    method:"get",
                    url:"/konfigurator_php/stocklogos/getVorschauSVG.php?id=" + stockLogoID
                }).then(response=>resolve(response.data)).catch(()=>console.log("could not load svg"))
            })
        }
    }
}

